export const Constants = {
  itemsClientInformations: [
    {
      title: 'Defensoría al cliente',
      url: 'http://www.defensoriadelclientedeabif.cl/Sitio/Inicio.aspx'
    },
    {
      title: 'Descargo de responsabilidad',
      url:
        'https://www.scotiabankchile.cl/Asistencia-al-Cliente/Normativos/descargo-responsabilidad'
    },
    {
      title:
        'Código de conducta y buena práctica de bancos e instituciones financieras',
      url:
        'http://cdn.agilitycms.com/scotiabank-chile/scotiabankpdf/asistencia/codigo_de_conducta.pdf'
    },
    {
      title: 'Prepagos y refinanciamiento de créditos',
      url:
        'http://cdn.agilitycms.com/scotiabank-chile/scotiabankpdf/asistencia/antec_prepago_refina.pdf'
    }
  ],
  itemsCorporateInformations: [
    {
      title: 'Manejo de información de interés para el mercado',
      url:
        'http://cdn.agilitycms.com/scotiabank-chile/scotiabankpdf/asistencia/manejoinfo.pdf'
    },
    {
      title:
        'Denuncias ley 20.393 sobre la responsabilidad penal de las personas jurídicas',
      url:
        'http://www.scotiabankchile.cl/Asistencia-al-Cliente/Normativos/denuncias-ley'
    },
    {
      title: 'Acuerdo de privacidad',
      url: 'https://www.scotiabankchile.cl/Personas/politica-de-privacidad'
    }
  ],
  itemsHelp: [
    {
      title: 'Sucursales más cercanas',
      url: 'https://www.scotiabankchile.cl/Personas/sucursales'
    },
    {
      title: 'Emergencias bancarias',
      url:
        'https://www.scotiabankchile.cl/Asistencia-al-Cliente/emergencias-bancarias'
    },
    {
      title: 'Atención al cliente',
      url: 'https://www.scotiabankchile.cl/Asistencia-al-Cliente/asistencia'
    }
  ],
  urlFacebook: 'https://www.facebook.com/ScotiabankCL',
  urlInstagram: 'https://www.instagram.com/scotiabank.cl/',
  urlYouTube: 'https://www.youtube.com/user/scotiabankchile',
  urlLinkedin: 'https://www.linkedin.com/company/scotiabank',
  urlTwitter: 'https://twitter.com/Scotiachile',
  textLegal:
    'Infórmese sobre el límite de garantía estatal de los depósitos en su banco o en',
  urlSbif: 'http://www.cmfchile.cl',
  textSbif: 'www.cmfchile.cl',
  textCopyright: '© 2022 Scotiabank',
  textCopyrightReservados: 'Todos los Derechos Reservados',
  errorSummary:
    'Lo sentimos, por el momento no podemos atender tu solicitud. Vuelve a intentarlo.',
  infoNoProduct:
    'Aún no has contratado este producto. Solo verás saldos una vez tengas el producto activo'
};
